<div id="logo">
  <img src="images/logo-sg.png" alt="">
</div>

<style>
  img {
    display: block;
    width: 100%;
  }
/* #logo {
  position: absolute;
  bottom: 0;


  right: 50px;
}


@media screen and (max-width: 800px) {
  #logo {
    position: absolute;
    bottom: 0;
    right: 10px;
    width: 150px;
  }
} */

</style>